"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentInput = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
const utils_1 = require("@/utils");
let CommentInput = class CommentInput extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = 'comment';
        this.placeholder = '';
        this.submitLabel = '댓글 게시';
    }
    render() {
        return (0, lit_1.html) `
      <form @submit=${this.handleCommentSubmit}>
        <mm-textarea
          name=${this.name}
          placeholder=${this.placeholder}
          @keydown=${this.handleTextareaKeydown}
        >
          <mm-button slot="trailing" variant="primary" @click=${this.handleCommentSubmit}>
            ${this.submitLabel}
          </mm-button>
        </mm-textarea>
      </form>
    `;
    }
    handleCommentSubmit(event) {
        event?.preventDefault();
        (0, utils_1.emit)(this, 'submit', {
            value: this.textarea?.value ?? '',
        });
    }
    handleTextareaKeydown(event) {
        // 슬롯에 둔 버튼의 키 입력도 mm-textarea를 거쳐 올라오므로 입력 영역에서 온 것만 받는다.
        if (event.target !== event.currentTarget)
            return;
        if (event.isComposing)
            return;
        if (event.key !== 'Enter' || event.shiftKey)
            return;
        event.preventDefault();
        this.handleCommentSubmit();
    }
};
CommentInput.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], CommentInput.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], CommentInput.prototype, "placeholder", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'submit-label' })
], CommentInput.prototype, "submitLabel", void 0);
__decorate([
    (0, decorators_js_1.query)('mm-textarea')
], CommentInput.prototype, "textarea", void 0);
CommentInput = __decorate([
    (0, decorators_js_1.customElement)('mm-comment-input')
], CommentInput);
exports.CommentInput = CommentInput;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbWVudC1pbnB1dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbW1lbnQtaW5wdXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUFrRTtBQUlsRSwrQkFBNEI7QUFDNUIsbUNBQThCO0FBR3ZCLElBQU0sWUFBWSxHQUFsQixNQUFNLFlBQWEsU0FBUSxnQkFBVTtJQUFyQzs7UUFNdUIsU0FBSSxHQUFHLFNBQVMsQ0FBQTtRQUNoQixnQkFBVyxHQUFHLEVBQUUsQ0FBQTtRQUNXLGdCQUFXLEdBQUcsT0FBTyxDQUFBO0lBb0M5RSxDQUFDO0lBakNDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBO3NCQUNPLElBQUksQ0FBQyxtQkFBbUI7O2lCQUU3QixJQUFJLENBQUMsSUFBSTt3QkFDRixJQUFJLENBQUMsV0FBVztxQkFDbkIsSUFBSSxDQUFDLHFCQUFxQjs7Z0VBRWlCLElBQUksQ0FBQyxtQkFBbUI7Y0FDMUUsSUFBSSxDQUFDLFdBQVc7Ozs7S0FJekIsQ0FBQTtJQUNILENBQUM7SUFFTyxtQkFBbUIsQ0FBQyxLQUFhO1FBQ3ZDLEtBQUssRUFBRSxjQUFjLEVBQUUsQ0FBQTtRQUV2QixJQUFBLFlBQUksRUFBQyxJQUFJLEVBQUUsUUFBUSxFQUFFO1lBQ25CLEtBQUssRUFBRSxJQUFJLENBQUMsUUFBUSxFQUFFLEtBQUssSUFBSSxFQUFFO1NBQ2xDLENBQUMsQ0FBQTtJQUNKLENBQUM7SUFFTyxxQkFBcUIsQ0FBQyxLQUFvQjtRQUNoRCwwREFBMEQ7UUFDMUQsSUFBSSxLQUFLLENBQUMsTUFBTSxLQUFLLEtBQUssQ0FBQyxhQUFhO1lBQUUsT0FBTTtRQUNoRCxJQUFJLEtBQUssQ0FBQyxXQUFXO1lBQUUsT0FBTTtRQUM3QixJQUFJLEtBQUssQ0FBQyxHQUFHLEtBQUssT0FBTyxJQUFJLEtBQUssQ0FBQyxRQUFRO1lBQUUsT0FBTTtRQUVuRCxLQUFLLENBQUMsY0FBYyxFQUFFLENBQUE7UUFDdEIsSUFBSSxDQUFDLG1CQUFtQixFQUFFLENBQUE7SUFDNUIsQ0FBQzs7QUExQ00sbUJBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7OztHQUlsQixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzswQ0FBaUI7QUFDaEI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2lEQUFpQjtBQUNXO0lBQXRELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLGNBQWMsRUFBRSxDQUFDO2lEQUFzQjtBQUN0RDtJQUFyQixJQUFBLHFCQUFLLEVBQUMsYUFBYSxDQUFDOzhDQUE0QjtBQVR0QyxZQUFZO0lBRHhCLElBQUEsNkJBQWEsRUFBQyxrQkFBa0IsQ0FBQztHQUNyQixZQUFZLENBNEN4QjtBQTVDWSxvQ0FBWSJ9